import axios from '@axios'

export default {
  namespaced: true,
  actions: {
    getMenu(context, hash) {
      return axios.get(`delivery/menu/${encodeURIComponent(hash)}`)
    },
    calculateDeliveryFee(context, payload) {
      return axios.post('delivery/calculate-fee', payload)
    },
    placeOrder(context, order) {
      return axios.post('delivery/orders', order)
    },
    getTracking(context, trackingCode) {
      return axios.get(`delivery/track/${encodeURIComponent(trackingCode)}`)
    },
    getOrders() {
      return axios.get('delivery-center/orders')
    },
    getOrderHistory(context, params) {
      return axios.get('delivery-center/orders/history', { params })
    },
    ensureMenuHash() {
      return axios.post('delivery-center/menu-link')
    },
    getWaiterTables(context, hash) {
      return axios.get(`delivery/waiter/${encodeURIComponent(hash)}`)
    },
    getWaiterProducts(context, { hash, search = '' }) {
      return axios.get(`delivery/waiter/${encodeURIComponent(hash)}/products`, {
        params: { search },
      })
    },
    openWaiterTable(context, { hash, tableNumber }) {
      return axios.post(`delivery/waiter/${encodeURIComponent(hash)}/tables`, {
        table_number: tableNumber,
      })
    },
    saveWaiterTableItems(context, { hash, orderId, items, append = false }) {
      return axios.put(`delivery/waiter/${encodeURIComponent(hash)}/tables/${orderId}`, {
        items,
        append,
      })
    },
    getKitchenOrders(context, hash) {
      return axios.get(`delivery/waiter/${encodeURIComponent(hash)}/kitchen/orders`)
    },
    updateKitchenOrder(context, { hash, batchId, status }) {
      return axios.patch(
        `delivery/waiter/${encodeURIComponent(hash)}/kitchen/orders/${encodeURIComponent(batchId)}`,
        { status },
      )
    },
    updateOrderStatus(context, { id, status, observation = '' }) {
      return axios.patch(`delivery-center/orders/${id}/status`, { status, observation })
    },
  },
}
